export enum ServicerType {
  CDE = 'CDE',
  OGInternal = 'OGInternal',
  OSS = 'OSS',
  KeiyouGas = 'KeiyouGas',
  SaibuGas = 'SaibuGas'
}
